import { GetUserScheduleDeskReservations as Reservation } from '../contexts/UserSchedule/hooks/__generated__/useUserOfficeSchedule.generated';
import {
  BookingPolicyType,
  DeskConfirmationStatus,
  UnconfirmableReasonType,
} from '../__generated__/types';

type ReservationInfo = {
  isAssigned: boolean;
  isAssignedNotConfirmed: boolean;
  isFlex: boolean;
  hasCheckIn: boolean;
  hasLocalCheckIn: boolean;
  checkInStatus: {
    checkInComplete: boolean;
    checkInRequiredFuture: boolean;
    checkInRequiredNow: boolean;
  };
};

//copy pasted from dashboard apps
export const getReservationInfo = (
  reservation?: Reservation
): ReservationInfo => {
  const isAssigned = reservation?.type === BookingPolicyType.ASSIGNED;
  const isFlex = reservation?.type !== BookingPolicyType.ASSIGNED;
  const hasCheckIn = !reservation?.confirmation?.unconfirmableReasons.some(
    ({ reason }) => reason === UnconfirmableReasonType.CHECKIN_DISABLED
  );

  const hasLocalCheckIn =
    !!reservation?.seat.reservationPolicies?.checkinPolicies
      ?.enforceLocalCheckinOnly;

  const checkInComplete =
    reservation?.confirmation?.status === DeskConfirmationStatus.CONFIRMED;
  const checkInRequiredNow =
    reservation?.confirmation?.status === DeskConfirmationStatus.UNCONFIRMED;
  const checkInRequiredFuture =
    reservation?.confirmation?.status ===
      DeskConfirmationStatus.CANNOT_CONFIRM &&
    reservation?.confirmation.unconfirmableReasons.some(
      ({ reason }) =>
        reason === UnconfirmableReasonType.OUTSIDE_OF_CHECK_IN_WINDOW
    );

  const isAssignedNotConfirmed =
    isAssigned && (checkInRequiredNow || checkInRequiredFuture);

  return {
    isAssigned,
    isAssignedNotConfirmed,
    isFlex,
    hasCheckIn: hasCheckIn,
    hasLocalCheckIn: hasLocalCheckIn,
    checkInStatus: {
      checkInComplete: checkInComplete,
      checkInRequiredNow: checkInRequiredNow,
      checkInRequiredFuture: checkInRequiredFuture,
    },
  };
};

export const getReservationTypeForBooking = (
  policyType: BookingPolicyType | undefined
): BookingPolicyType => {
  switch (policyType) {
    case BookingPolicyType.HOT:
    case BookingPolicyType.HOTELED:
      return policyType;

    case BookingPolicyType.ASSIGNED:
    case BookingPolicyType.SHARED:
      return BookingPolicyType.REVERSE_HOTEL;

    default:
      return BookingPolicyType.HOT;
  }
};
